<template>
    <div>
        <!-- <div v-for="(list, index) in statusType" :key="index"> -->
        <span class="status-view-grid" :class="statusClass">
            <i :class="statusIcon"></i>
        </span>
        <!-- </div> -->
    </div>
</template>

<script>
    export default {
        components: {},

        /*
        |--------------------------------------------------------------------------
        | Component > props
        |--------------------------------------------------------------------------
        */
        props: {
            statusType: {
                type: String,
                default: null,
            },
        }, // End of Component > props

        /*
        |--------------------------------------------------------------------------
        | Component > data
        |--------------------------------------------------------------------------
        */
        data() {
            return {}
        }, // End of Component > data

        /*
        |--------------------------------------------------------------------------
        | Component > computed
        |--------------------------------------------------------------------------
        */
        computed: {
            statusIcon() {
                if(this.statusType == 'warning'){
                    return 'icon-warning'
                }
                if (this.statusType == 'active') {
                    return 'icon-check'
                }
                if (this.statusType == 'notfound') {
                    return 'icon-check'
                }
                if (this.statusType == 'locked') {
                    return 'icon-change-password'
                }
                if (
                    this.statusType == 'pending' ||
                    this.statusType == 'potential'
                ) {
                    return 'icon-loading'
                }
                if (this.statusType == 'high') {
                    return 'icon-high-risk'
                }
                if (this.statusType == 'low') {
                    return 'icon-low-risk'
                }
                if (this.statusType == 'medium') {
                    return 'icon-medium-risk'
                }
                if (this.statusType == 'sanction') {
                    return 'icon-sanction'
                }
                if (
                    this.statusType == 'approved' ||
                    this.statusType == 'Submitted' ||
                    this.statusType == 'matched' ||
                    this.statusType == 'completed'
                ) {
                    return 'icon-check'
                }
                if (this.statusType == 'hit' || this.statusType == "notmatched" || this.statusType == "found" ) {
                    return 'icon-wrong'
                }
                if (this.statusType == '') {
                    return 'icon-loading'
                    // return 'icon-check'
                }
                if (this.statusType == 'return-alert') {
                    return 'icon-wrong'
                }
                return 'icon-wrong'
            },
            statusClass() {
                if (this.statusType == 'active') {
                    return 'approved'
                }
                if (this.statusType == 'locked') {
                    return 'locked'
                }
                if (
                    this.statusType == 'pending' ||
                    this.statusType == 'potential'||
                    this.statusType == 'warning'
                ) {
                    return 'pending'
                }

                if (this.statusType == 'high') {
                    return 'high-risk'
                }
                if (this.statusType == 'low') {
                    return 'low-risk'
                }
                if (this.statusType == 'medium') {
                    return 'medium-risk'
                }
                if (this.statusType == 'sanction') {
                    return 'sanctioned-risk'
                }
                if (
                    this.statusType == 'approved' ||
                    this.statusType == 'Submitted' ||
                    this.statusType == 'matched' ||
                    this.statusType == 'notfound' ||
                    this.statusType == 'completed'
                ) {
                    return 'approved'
                }
                if (this.statusType == 'hit' || this.statusType == "notmatched") {
                    return 'high-risk'
                }
                if (this.statusType == '') {
                    return 'pending'
                    // return 'low-risk'
                }
                if (this.statusType == 'return-alert') {
                    return 'rejected'
                }
                if (this.statusType == 'expired') {
                    return 'rejected'
                }
                return 'rejected'
            },
            statusLabel() {
                if (this.statusType == 'active') {
                    return 'Active'
                }
                if (this.statusType == 'locked') {
                    return 'Locked'
                }
                if (this.statusType == 'pending') {
                    return ''
                    // return 'Pending'
                }
                if (this.statusType == 'potential') {
                    return 'Potential'
                }
                if (this.statusType == 'high') {
                    return 'High Risk'
                }
                if (this.statusType == 'low') {
                    return 'Low Risk'
                }
                if (this.statusType == 'medium') {
                    return 'Medium Risk'
                }
                if (this.statusType == 'sanction') {
                    return 'Sanctioned'
                }
                if (this.statusType == 'approved') {
                    return 'Approved'
                }
                if (this.statusType == 'Submitted') {
                    return 'Submitted'
                }
                if (this.statusType == 'matched') {
                    return ''
                    // return 'Matched'
                }
                if (this.statusType == 'notmatched') {
                    return ''
                    // return 'Not Matched'
                }
                if (this.statusType == 'notfound') {
                    return ''
                    // return 'Not Found'
                }
                if (this.statusType == 'found') {
                    return ''
                    // return 'Record Found'
                }
                if (this.statusType == 'rejected') {
                    return 'Rejected'
                }
                if (this.statusType == 'expired') {
                    return 'Expired'
                }
                if (this.statusType == 'hit') {
                    return 'Genuine'
                }
                if (this.statusType == '') {
                    return ''
                    // return 'Not Genuine'
                }
                if (this.statusType == 'return-alert') {
                    return 'Returned'
                }
                return 'Archived'
            },
        }, // End of Component > methods

        /*
        |--------------------------------------------------------------------------
        | Component > mounted
        |--------------------------------------------------------------------------
        */
        mounted() {}, // End of Component > computed

        /*
        |--------------------------------------------------------------------------
        | Component > methods
        |--------------------------------------------------------------------------
        */
        methods: {}, // End of Component > mounted
    } // End of export default
</script>
